var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransaction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 23,
    viewBox: "0 0 18 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 3.5H2.5C1.94772 3.5 1.5 3.94772 1.5 4.5V20.5C1.5 21.0523 1.94772 21.5 2.5 21.5H15.5C16.0523 21.5 16.5 21.0523 16.5 20.5V4.5C16.5 3.94772 16.0523 3.5 15.5 3.5Z",
    stroke: "#212121",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 1.5V4.5M12 1.5V4.5M5 9H13M5 13H11M5 17H9",
    stroke: "#212121",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransaction);
export default __webpack_public_path__ + "static/media/transaction.21baef8fab3d990efb91de0a02b2d9f7.svg";
export { ForwardRef as ReactComponent };